import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { SnackbarProvider } from 'notistack'
import * as ReactDOM from 'react-dom/client'
import AppRouter from './AppRouter'
import AuthProvider from './contexts/Auth/AuthProvider'
import { ConfettiContextProvider } from './contexts/ConfettiProvider'
import { EventStreamProvider } from './contexts/EventStream/EventStreamProvider'
import { UrqlProvider } from './contexts/UrqlProvider'
import theme from './theme'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <ThemeProvider theme={theme}>
      <CssBaseline enableColorScheme />
      <UrqlProvider>
        <AuthProvider>
          <EventStreamProvider>
            <ConfettiContextProvider>
              <SnackbarProvider>
                <AppRouter />
              </SnackbarProvider>
            </ConfettiContextProvider>
          </EventStreamProvider>
        </AuthProvider>
      </UrqlProvider>
    </ThemeProvider>
  </LocalizationProvider>,
)
